<template>
  <el-button :file-key="fileKey" size="mini" type="warning" @click="downLoadFile">下载</el-button>
</template>

<script>
  export default {
    props: {
      fileKey: {
        type: String,
        default: "",
      },
    },

    methods: {
      downLoadFile() {
        if (this.fileKey) {
          this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(this.fileKey)}`).then((res) => {
            if (res.success) {
              window.open(res.data);
            }
          });
        }
      },
    },
  };
</script>
